(() => {
const link = document.querySelector('[data-pk-whatsapp]');
if (!link || window.pkWhatsappReady) return;
window.pkWhatsappReady = true;
let frame = 0;
const update = () => {
 frame = 0;
 const focus = document.activeElement;
 const typing = matchMedia('(max-width:900px)').matches && focus?.matches('input,textarea,select,[contenteditable=true]');
 const modal = document.body.classList.contains('pk-signup-open') || document.querySelector('dialog[open],[aria-modal=true]:not([hidden])')?.getBoundingClientRect().width > 0;
 const r = link.getBoundingClientRect();
 const overlap = Array.from(document.querySelectorAll('main button[type=submit],main .button,main [data-cart-step],main input,main select,.cart-notice:not([hidden]),.mobile-menu[data-open]')).some(el => {
 const b = el.getBoundingClientRect();
 return b.width && b.height && b.left < r.right + 8 && b.right > r.left - 8 && b.top < r.bottom + 8 && b.bottom > r.top - 8;
 });
 const away = Boolean(typing || modal || overlap);
 if (!link.matches(':focus-visible')) {
 if (link.classList.contains('is-away') !== away) link.classList.toggle('is-away', away);
 if (away) link.setAttribute('tabindex','-1'); else link.removeAttribute('tabindex');
 }
};
const schedule = () => {if (!frame) frame = requestAnimationFrame(update);};
addEventListener('scroll',schedule,{passive:true});
addEventListener('resize',schedule,{passive:true});
document.addEventListener('focusin',schedule);
document.addEventListener('focusout',schedule);
new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
window.visualViewport?.addEventListener('resize',schedule,{passive:true});
update();
})();